import { notification } from "antd";

import { appsignal } from "appsignal";

const DEFAULT_USER_MESSAGE = "Something went wrong. Please try again.";

const stringifyError = (error: unknown) => {
  if (typeof error === "string") return error;

  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
};

const withContextMessage = (error: Error, message: string) => {
  const errorWithContext = error as Error & { contextMessage?: string };

  errorWithContext.contextMessage = message;
  return errorWithContext;
};

export const reportVeriffError = (message: string, error: unknown, userMessage = DEFAULT_USER_MESSAGE) => {
  if (error instanceof Error) {
    appsignal.sendError(withContextMessage(error, message));
    notification.error({ message: userMessage });
    return;
  }

  appsignal.sendError(new Error(`${message}: ${stringifyError(error)}`));
  notification.error({ message: userMessage });
};
